export const IMG = {
  goat: "https://feralcollective.co.uk/hero-goat.jpg",
  exterior: "https://feralcollective.co.uk/plas-exterior.jpeg",
  interior: "https://feralcollective.co.uk/plas-interior.jpg",
  estate: "https://feralcollective.co.uk/legacy/_landscape169/4515/Photo-3.webp",
  courtyard1: "https://feralcollective.co.uk/legacy/_landscape169/4354/DSC2939.webp",
  courtyard2: "https://feralcollective.co.uk/legacy/_landscape169/4355/DSC2943.webp",
  farmhouse: "https://feralcollective.co.uk/legacy/_landscape169/4356/DSC4461.webp",
  farmhouse2: "https://feralcollective.co.uk/legacy/_landscape169/4357/DSC4734.webp",
  retreat1: "https://feralcollective.co.uk/legacy/_landscape169/4358/Feral-Retreat-3_WR_2026-03-19-150724_dpim.webp",
  retreat2: "https://feralcollective.co.uk/legacy/_landscape169/4360/Feral-Retreat-85_WR_2026-03-19-150727_cmlw.webp",
  retreat3: "https://feralcollective.co.uk/legacy/_landscape169/4362/Feral-Retreat-140_WR_2026-03-19-150730_nivn.webp",
  retreat4: "https://feralcollective.co.uk/legacy/_landscape169/4364/Feral-Retreat-163_WR_2026-03-19-150732_otwl.webp",
  community: "https://feralcollective.co.uk/hero-community.jpg",
  laughing: "https://feralcollective.co.uk/hero-laughing.jpg",
  manorInterior: "https://feralcollective.co.uk/hero-interior.jpg",
  weddingBarn: "https://images.unsplash.com/photo-1588963200960-44cf8e2b6fed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxydXN0aWMlMjBiYXJuJTIwd2VkZGluZ3xlbnwwfHx8fDE3OTA1MzkxNTV8MA&ixlib=rb-4.1.0&q=85",
  firepit: "https://images.unsplash.com/photo-1779202730803-e5a924592475?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxjb2FzdGFsJTIwY290dGFnZSUyMGludGVyaW9yJTIwZmlyZXBpdHxlbnwwfHx8fDE3OTA1MzkxNTV8MA&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { value: "8", label: "Luxury courtyard cottages" },
  { value: "20", label: "Bedrooms across the estate" },
  { value: "40", label: "Guests under one roof" },
  { value: "1", label: "Wild island on the doorstep" },
];

export const COTTAGES = [
  { name: "Y Stabl", meaning: "The Stable", sleeps: 2, img: IMG.courtyard1, blurb: "A snug hideaway for two with a log fire and stable-door mornings." },
  { name: "Y Beudy", meaning: "The Byre", sleeps: 2, img: IMG.courtyard2, blurb: "Stone walls, soft linen and a private corner of the courtyard." },
  { name: "Tŷ Gwyn", meaning: "The White House", sleeps: 4, img: IMG.farmhouse, blurb: "Light-filled rooms and long breakfasts around the farmhouse table." },
  { name: "Ysgubor Fach", meaning: "The Little Barn", sleeps: 4, img: IMG.courtyard1, blurb: "Beamed ceilings, a deep sofa and evenings by the fire." },
  { name: "Hafod", meaning: "The Summer Dwelling", sleeps: 4, img: IMG.farmhouse2, blurb: "Made for slow summers — doors thrown open to the fields." },
  { name: "Tŷ Newydd", meaning: "The New House", sleeps: 6, img: IMG.courtyard2, blurb: "Room for the whole crew, with feasting space at its heart." },
  { name: "Y Granar", meaning: "The Granary", sleeps: 6, img: IMG.farmhouse, blurb: "Three bedrooms, a big kitchen and sunset views over the pond." },
  { name: "Gardd y Môr", meaning: "Garden of the Sea", sleeps: 6, img: IMG.estate, blurb: "The largest cottage, moments from the wild Rhosneigr shore." },
];

export const FACILITIES = [
  "20 bedrooms across cottages & farmhouse",
  "Sleeps up to 40 guests",
  "Log fires throughout",
  "Hot tubs under dark skies",
  "Rustic spa rituals",
  "Outdoor feasting & fire pits",
  "Wild swimming pond",
  "Resident goats — the FERAL Mowers",
  "Dog friendly, surrounded by dog fields",
  "Beautiful sunset views",
];

export const RETREATS = [
  { title: "Nature Retreat", img: IMG.retreat1, copy: "Anglesey is an Area of Outstanding Natural Beauty with some of the darkest skies for stargazing. Slow down, walk the coast, watch the wildlife and reconnect with the land." },
  { title: "Watersports Retreat", img: IMG.retreat2, copy: "The island is a watersports playground. Sail, surf, paddle or coasteer your way around the coastline with our trusted local guides." },
  { title: "Wellness Retreat", img: IMG.retreat3, copy: "Salt air, open landscapes and sensory healing. Our wellness retreats use the power of nature to strip away the noise and leave you re-energised." },
  { title: "Fitness Retreat", img: IMG.retreat4, copy: "A holistic, feel-good approach to movement in a wild setting. Yoga, pilates, strength or a sport of your choice — designed around you." },
];

export const GALLERY = [
  { src: IMG.exterior, cat: "Estate", alt: "The courtyard estate from the fields" },
  { src: IMG.goat, cat: "Goats & Grounds", alt: "One of the resident FERAL Mowers" },
  { src: IMG.interior, cat: "Interiors", alt: "Cottage interior with log fire" },
  { src: IMG.estate, cat: "Estate", alt: "Golden hour across the grounds" },
  { src: IMG.courtyard1, cat: "Estate", alt: "The stone courtyard" },
  { src: IMG.manorInterior, cat: "Interiors", alt: "Gathering lounge" },
  { src: IMG.community, cat: "Gatherings", alt: "Feasting together outdoors" },
  { src: IMG.farmhouse, cat: "Interiors", alt: "The farmhouse kitchen table" },
  { src: IMG.farmhouse2, cat: "Goats & Grounds", alt: "Open fields and big skies" },
  { src: IMG.laughing, cat: "Gatherings", alt: "Laughter around the fire" },
  { src: IMG.courtyard2, cat: "Estate", alt: "Cottage doors on the courtyard" },
  { src: IMG.retreat3, cat: "Goats & Grounds", alt: "Wild corners of the estate" },
];

export const MARQUEE_ITEMS = [
  "Historic courtyard estate",
  "Rhosneigr · Anglesey",
  "Log fires & hot tubs",
  "Wild coastal feasts",
  "The FERAL Mowers",
  "Dog friendly · dog fields",
  "Beautiful sunset views",
  "Sleeps up to 40",
];
